<template lang="en">
<div class="doctor-profile">
    <Navigation></Navigation>
    <div id="breadcrumb">
        <div class="container">
            <ul>
                <li><router-link tag="a" to="/">Inicio</router-link></li>
                <li>Política de privacidad</li>
            </ul>
        </div>
    </div>

    <div class="bg_color_1">
        <div class="container margin_120_95">
            <div class="main_title text-left">
                <h1>Política de privacidad</h1>
            </div>
            <div class="row justify-content-between">
                <div class="col-12">
                    <div class="justify-text" v-html="privacy"></div>
                </div>
            </div>
        </div>
    </div>
    

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export default {
    name: 'Privacy',
    metaInfo: {
		title: 'Política de privacidad',
	},
    components: {
        Navigation,
        Footer,
    },
    data() {
        return {
            privacy: null
        }
	},
    beforeMount(){
		this.loadSettings()
	},
	methods:{
		loadSettings(){
            this.$apollo.query({
				query: gql`query getSettings {
					settings{
                        privacy
					}
                }`,
			})
			.then((data) => {
                this.privacy = data.data.settings.privacy
			});
        },
	}

}
</script>

<style scoped>

</style>
